/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetTeamMemberNotificationSettingsRequest} from '@cash-web/protos/squareup/timecards/scheduling/notifications.pb'
import {GetTeamMemberNotificationSettingsResponse} from '@cash-web/protos/squareup/timecards/scheduling/notifications.pb'


export const getTeamMemberNotificationSettings = (request: GetTeamMemberNotificationSettingsRequest, options?: CashRequestOptions) => post<GetTeamMemberNotificationSettingsRequest, GetTeamMemberNotificationSettingsResponse>("/2.0/cash/get-team-member-notification-settings", request, {...options, rejectOnError: true })